import React from 'react';
import { Parallax } from 'react-scroll-parallax';
import styled from 'styled-components';
import beeGoodBadge from '../images/bee-good-badge.svg';
import ourBeesDontStingBadge from '../images/our-bees-dont-sting-badge.svg';

const StyledBeeBadge = styled.div`
  width: 100%;
  max-width: 240px;
`;

const StyledImage = styled.img`
  width: 100%;
`;

const BeeBadge = ({ alt, isFooter, ...props }) => (
  <StyledBeeBadge {...props}>
    <Parallax rotate={[45, 0]}>
      <StyledImage
        src={alt ? ourBeesDontStingBadge : beeGoodBadge}
        alt={
          alt ? '' : 'Bee Good! Switch to ecotalk and protect nature in Britain'
        }
        {...(isFooter && {
          loading: 'lazy',
        })}
      />
    </Parallax>
  </StyledBeeBadge>
);

export default BeeBadge;
